export enum NavType {
  user = 'user',
  starter = 'starter',
}
